import Scene, { ISceneParams } from './Scene';
import Game from 'Game';
import RenderSystem from 'System/Render/RenderSystem';
import WorldSystem from 'System/World/WorldSystem';
import AnimationSystem from 'System/Animation/AnimationSystem';
import TimerSystem from 'System/Timer/TimerSystem';
import WorldUISystem from 'System/UI/WorldUISystem';
import FieldSystem from 'System/Field/FieldSystem';
import { WorldDataHelper } from "Utility/WorldDataHelper";
import AudioSystem from "System/Audio/AudioSystem";

export interface IWorldSceneParams extends ISceneParams {
    worldNumber: number;
}

export default class WorldScene extends Scene {
    public params: IWorldSceneParams;
    public layout: any;

    public init(): void {
        this.addSystem(new TimerSystem(Game.store));
        this.addSystem(new WorldSystem(Game.store, this.params.worldNumber));
        this.addSystem(new WorldUISystem(Game.store));
        this.addSystem(new AnimationSystem(Game.store));
        this.addSystem(new RenderSystem(Game.store));
        this.addSystem(new FieldSystem(Game.store));
        this.addSystem(new AudioSystem(Game.store));

        this.systems.forEach(system => system.init());
    }

    public start() {
        this.layout = WorldDataHelper.createWorldLayout(this.params.worldNumber);
        super.start();
    }
}
